import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteMeetingItem } from '../api/meetingApi'

/**
 * Gündem/prensip/karar maddesi silme (2026-09-11, kullanıcı isteği) — `RECORD_DELETE` yetkisi olan ama
 * tutanağı düzenleme yetkisi (`MINUTES_CREATE`) olmayan kullanıcı için (ör. Genel Müdür).
 *
 * <p>Düzenleme yetkisi olanlar maddeyi zaten editörden (senkron ucu) kaldırıyor; bu mutasyon salt-okuma
 * görünümündeki çöp kutusu düğmesini besler. Başarıda toplantı detayı tazelenir — liste, madde numaraları
 * ve İşlem Geçmişi aynı sorgudan gelir.
 */
export function useDeleteMeetingItem(meetingId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (itemId: number) => deleteMeetingItem(meetingId, itemId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['meeting-detail', meetingId] })
      qc.invalidateQueries({ queryKey: ['meeting-logs', meetingId] })
    },
  })
}
